import { type FormEvent, useState } from "react";

type LandingPageProps = {
  initialSid?: string;
  label?: string;
  buttonLabel?: string;
};

export default function LandingPage({
  initialSid = "",
  label = "Enter session ID",
  buttonLabel = "OK",
}: LandingPageProps) {
  const [sidInput, setSidInput] = useState(initialSid);

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();

    const trimmed = sidInput.trim();
    if (!trimmed) return;

    const params = new URLSearchParams(window.location.hash.slice(1));
    params.set("sid", trimmed);

    window.location.hash = params.toString();
  };

  return (
    <div className="card text-center mb-6 mt-3 landing-page">
      <div className="flex flex-col items-center gap-3 px-4 py-6">
        <form
          onSubmit={handleSubmit}
          className="flex flex-col sm:flex-row gap-3 items-stretch sm:items-center w-full max-w-md"
        >
          <label className="flex-1 text-left text-sm text-white/80">
            {label}
            <input
              type="text"
              value={sidInput}
              onChange={(e) => setSidInput(e.target.value)}
              className="mt-1 w-full rounded-md border border-white/20 bg-black/30 px-3 py-2 text-white placeholder-white/40 focus:outline-none focus:ring-2 focus:ring-white/60"
              placeholder="abc-def-ghi"
            />
          </label>

          <button
            type="submit"
            disabled={!sidInput.trim()}
            className="sm:w-auto w-full rounded-md font-medium px-4 py-2 disabled:opacity-50 disabled:cursor-not-allowed hover:bg-white"
          >
            {buttonLabel}
          </button>
        </form>
      </div>
    </div>
  );
}
